<template>
  <!-- Highlight section -->
  <section class="highlight-section has-text-centered">
    <div class="highlight-section-content">
      <h1 class="highlight-section-title">
        {{ $t('page.whatIsLiffery.areYouBusiness.title') }}
      </h1>
      <p class="highlight-section-text">
        {{ $t('page.whatIsLiffery.areYouBusiness.text') }}<br/>
        <br/>
        <router-link class="link-dark" :to="{name: routeNames.ROUTE_INFO_BUSINESS}">
          <b-button type="is-primary" class="is-outlined">
            {{ $t('page.whatIsLiffery.areYouBusiness.linkText') }}
          </b-button>
        </router-link>
      </p>
    </div>
    <div class="highlight-section-line-top"></div>
    <div class="highlight-section-line-bottom"></div>
  </section>
</template>

<style scoped lang="scss">
.highlight-section {
  position: relative;
  overflow: hidden;
  padding: 7.353rem 6.875rem;
  color: $white;
  background-color: $primary;

  &-content {
    position: relative;
    z-index: 1;
    max-width: 52.95rem;
    margin: 2rem auto 2rem;
  }

  &-title {
    font-size: $fontH1Size !important;
  }

  &-text {
    margin-top: 2rem;
    line-height: 20px !important;
  }

  &-line-top {
    content: url("../../../../assets/landing-pages/new/line-down.svg");
    position: absolute;
    top: -15rem;
    left: -2rem;
    transform: rotate(5deg);
    pointer-events: none;
  }

  &-line-bottom {
    content: url("../../../../assets/landing-pages/new/line-up.svg");
    position: absolute;
    top: -2rem;
    right: 0;
    pointer-events: none;
  }

  @media screen and (max-width: $desktop) {
    &-line-top {
      top: -20rem;
      left: -10rem;
    }

    &-line-bottom {
      top: 1rem;
      right: 0;
    }
  }

  @media screen and (max-width: $tablet) {
    padding-right: 2rem;
    padding-left: 2rem;

    &-title {
      font-size: 24px !important;
    }

    &-text {
      margin-top: 1rem;
    }

    &-line-bottom {
      transform: rotate(5deg);
    }
  }

  @media screen and (max-width: $smallMobile) {
    &-line-top {
      left: -30rem;
    }
  }
}

</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { RouteNames } from '@/router/RouteNames';

@Component
export default class OAreYouABusiness extends Vue {
  routeNames = RouteNames;
}
</script>
